import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=c7a77c4a&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=c7a77c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a77c4a",
  null
  
)

export default component.exports